import React from "react";
import { Box, Button } from "@mui/material";

const buttonSx = {
  whiteSpace: "nowrap",
  fontWeight: 500,
  height: "32px",
  minWidth: { sm: "120px" },
};

const RhpActionButtons = ({
  onSaveAndPrint,
  onSaveAndTakeNew,
  onSaveForLater,
  isLoading = false,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        alignItems: { xs: "stretch", sm: "center" },
        gap: 1,
        justifyContent: "flex-end",
        pt: 1,
        px: 0,
        backgroundColor: "#fff",
        borderRadius: 0,
        width: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          flexWrap: "wrap",
          gap: 1,
          justifyContent: "flex-end",
          width: { xs: "100%", sm: "auto" },
        }}
      >
        <Button
          variant="contained"
          size="medium"
          onClick={onSaveAndPrint}
          disabled={isLoading}
          sx={{
            ...buttonSx,
            backgroundColor: "#F8991D",
            color: "#fff",
            "&:hover": { backgroundColor: "#e08a15" },
          }}
        >
          {isLoading ? "Saving..." : "Save & Print"}
        </Button>
        <Button
          variant="outlined"
          size="medium"
          onClick={onSaveAndTakeNew}
          disabled={isLoading}
          sx={{
            ...buttonSx,
            // backgroundColor: "#2e7d32",
            // color: "#fff",
            // "&:hover": { backgroundColor: "#1b5e20" },
            borderColor: "#000",
            color: "#000",
            "&:hover": {
              backgroundColor: "#f5f5f5",
              borderColor: "#000",
            },
          }}
        >
          {isLoading ? "Saving..." : "Save & Take New"}
        </Button>
        <Button
          variant="outlined"
          size="medium"
          onClick={onSaveForLater}
          disabled={isLoading}
          sx={{
            ...buttonSx,
            borderColor: "#000",
            color: "#000",
            "&:hover": {
              backgroundColor: "#f5f5f5",
              borderColor: "#000",
            },
          }}
        >
          Save for Later
        </Button>
      </Box>
    </Box>
  );
};

export default RhpActionButtons;
